"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dropdownindicator = _interopRequireDefault(require("../../searchabledropdown/multiselect/dropdownindicator/dropdownindicator"));

var _index = require("../../../../material/index");

var _index2 = require("../../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _rangepicker_styles = _interopRequireDefault(require("./rangepicker_styles"));

var _rangepicker_definition = _interopRequireDefault(require("./rangepicker_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : DROPDOWN : RANGE PICKER ~~~~~~~~~~ ========== */


var DateRangePickerDropDown =
/*#__PURE__*/
function (_Component) {
  _inherits(DateRangePickerDropDown, _Component);

  function DateRangePickerDropDown(props) {
    var _this;

    _classCallCheck(this, DateRangePickerDropDown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePickerDropDown).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      // ignore clicks on the component itself
      if (!_this.node.contains(e.target) && _this.state.active) {
        _this.hideMenu();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInitialIndicator", function (from, to) {
      if (!from || !to) return 'Anytime';
      var fromDate = new Date(from.split('-').join("/"));
      var toDate = new Date(to.split('-').join("/"));
      var dateRangeLength = Math.floor((toDate - fromDate) / 86400000 + 1);

      switch (dateRangeLength) {
        case 7:
        case 30:
        case 90:
        case 180:
          return "Last ".concat(dateRangeLength, " days");

        default:
          return _this.changeDateFormat(from) + ' - ' + _this.changeDateFormat(to);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeDateFormat", function (iso) {
      var date = _this.handleDatePickerFormat(iso);

      return "".concat((0, _index2.zeroPadding)(date.getMonth() + 1, 2), "/").concat((0, _index2.zeroPadding)(date.getDate(), 2), "/").concat((0, _index2.getLastTwoDigit)(date.getFullYear()));
    });

    _defineProperty(_assertThisInitialized(_this), "rangeFormat", function (range) {
      var to = range.to,
          from = range.from;
      return !to || !from ? _this.props.range : {
        from: "".concat(from.getFullYear(), "-").concat((0, _index2.zeroPadding)(from.getMonth() + 1, 2), "-").concat((0, _index2.zeroPadding)(from.getDate(), 2)),
        to: "".concat(to.getFullYear(), "-").concat((0, _index2.zeroPadding)(to.getMonth() + 1, 2), "-").concat((0, _index2.zeroPadding)(to.getDate(), 2))
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleRangeSelect", function (range) {
      _this.setState({
        indicator: null
      });

      var rangeFormat = _this.rangeFormat(range);

      _this.props.updateRange(rangeFormat);
    });

    _defineProperty(_assertThisInitialized(_this), "showMenu", function () {
      return _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideMenu", function () {
      _this.setState({
        active: false,
        customClicked: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      return _this.state.active ? _this.hideMenu() : _this.showMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "renderRange", function () {
      var to = _this.handleDatePickerFormat(_this.props.range.to);

      var from = _this.handleDatePickerFormat(_this.props.range.from);

      return _this.state.indicator ? "".concat(_this.state.indicator) : to ? "".concat((0, _index2.zeroPadding)(from.getMonth() + 1, 2), "/").concat((0, _index2.zeroPadding)(from.getDate(), 2), "/").concat((0, _index2.getLastTwoDigit)(from.getFullYear()), " - ").concat((0, _index2.zeroPadding)(to.getMonth() + 1, 2), "/").concat((0, _index2.zeroPadding)(to.getDate(), 2), "/").concat((0, _index2.getLastTwoDigit)(to.getFullYear())) : "Select dates";
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonClickAndApply", function (range) {
      return _this.props.customRangeClick(range);
    });

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function (rangeLength, indicator) {
      var rangeFormat = {
        from: null,
        to: null
      };

      switch (rangeLength) {
        case 'YESTERDAY':
          var yesterday = new Date(new Date() - 1000 * 60 * 60 * 24);
          rangeFormat = _this.rangeFormat({
            from: yesterday,
            to: yesterday
          });
          break;

        case 'TODAY':
          var today = new Date();
          rangeFormat = _this.rangeFormat({
            from: today,
            to: today
          });
          break;

        case null:
          break;

        default:
          rangeFormat = _this.rangeFormat({
            from: new Date(new Date() - 1000 * 60 * 60 * 24 * rangeLength),
            to: new Date(new Date() - (_this.props.use4PMLogic ? (0, _index2.isAfterFourPM)() ? 1000 * 60 * 60 * 24 : 1000 * 60 * 60 * 24 * 2 : 1000 * 60 * 60 * 24))
          });
      }

      !!_this.props.customDateRanges && !_this.state.customClicked ? _this.handleButtonClickAndApply(rangeFormat) : _this.props.updateRange(rangeFormat);

      _this.setState({
        indicator: indicator ? indicator : "Last ".concat(rangeLength, " days")
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleApply", function () {
      _this.props.handleApply && _this.props.handleApply();

      _this.hideMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      _this.setState({
        indicator: 'Select dates'
      });

      !!_this.props.customDateRanges && _this.props.updateRange({
        from: null,
        to: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDatePickerFormat", function (date) {
      return date === null ? null : new Date(date.split('-').join("/"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCTAs", function () {
      if (_this.props.customDateRanges) {
        return _react.default.createElement(_index.CTAs, {
          name: "date-ranges hide-".concat(_this.props.hideDateRangeHelpers ? 'true' : 'false')
        }, _this.props.customDateRanges.map(function (range) {
          return _react.default.createElement(_index.Button, {
            handleClick: function handleClick() {
              return _this.handleButtonClick(range.range, range.indicator);
            },
            text: range.ctaText,
            variant: "normal"
          });
        }), _react.default.createElement(_index.Link, {
          type: 'action',
          color: 'primary',
          text: 'Custom',
          icon: 'calendar',
          action: _this.handleCustomCTAClick
        }));
      }

      return _react.default.createElement(_index.CTAs, {
        name: "date-ranges hide-".concat(_this.props.hideDateRangeHelpers ? 'true' : 'false')
      }, _react.default.createElement(_index.Button, {
        handleClick: function handleClick() {
          return _this.handleButtonClick(7);
        },
        text: "Last 7 days",
        variant: "normal"
      }), _react.default.createElement(_index.Button, {
        handleClick: function handleClick() {
          return _this.handleButtonClick(30);
        },
        text: "Last 30 days",
        variant: "normal"
      }), _react.default.createElement(_index.Button, {
        handleClick: function handleClick() {
          return _this.handleButtonClick(90);
        },
        text: "Last 90 days",
        variant: "normal"
      }), _react.default.createElement(_index.Button, {
        handleClick: function handleClick() {
          return _this.handleButtonClick(180);
        },
        text: "Last 180 days",
        variant: "normal"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "handleCustomCTAClick", function () {
      return _this.setState({
        customClicked: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCalendar", function () {
      if (!_this.props.customDateRanges || _this.props.customDateRanges && _this.state.customClicked) {
        return _react.default.createElement("div", {
          className: 'datepickerapply'
        }, _react.default.createElement(_index.DatePicker, {
          range: {
            from: _this.props.range.from,
            to: _this.props.range.to
          },
          handleRangeSelect: _this.handleRangeSelect,
          disabledDays: _this.props.disabledDays,
          numberOfMonths: 2
        }), _react.default.createElement(_index.CTAs, {
          name: "clear-apply hide-".concat(_this.props.hideButtons ? 'true' : 'false')
        }, _react.default.createElement(_index.Link, {
          type: "action",
          action: _this.handleClear,
          color: "primary",
          text: "Clear"
        }), _this.props.range.to && _react.default.createElement(_index.Link, {
          type: "action",
          action: _this.handleApply,
          color: "primary",
          text: "Apply"
        })));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderIndicator", function () {
      if (_this.props.indicatorTitle) {
        return _react.default.createElement(_dropdownindicator.default, {
          active: _this.state.active,
          title: _this.renderRange(),
          name: _this.props.indicatorTitle,
          icon: 'calendar-alt',
          toggleMenu: _this.handleClick
        });
      }

      return _react.default.createElement("div", {
        className: "placeholder active-".concat(_this.state.active),
        onClick: _this.handleClick
      }, _react.default.createElement("span", null, _this.renderRange()), _react.default.createElement(_index.Icon, {
        name: "sort-down"
      }));
    });

    _this.state = {
      active: false,
      customClicked: false,
      indicator: props.hideButtons ? _this.changeDateFormat(props.range.from) + ' - ' + _this.changeDateFormat(props.range.to) : _this.handleInitialIndicator(props.range.from, props.range.to)
    };

    _this.handleInitialIndicator(props.range.from, props.range.to);

    return _this;
  }

  _createClass(DateRangePickerDropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var active = this.state.active;
      return _react.default.createElement("div", {
        className: "datepickerdropdown rangepickerdropdown dropdown ".concat(this.props.classes.rangepickerdropdown),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, this.renderIndicator(), _react.default.createElement(_index.Group, {
        name: "dropdown active-".concat(active, " customClicked-").concat(this.state.customClicked)
      }, this.renderCTAs(), this.renderCalendar()));
    }
  }]);

  return DateRangePickerDropDown;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(DateRangePickerDropDown, _rangepicker_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_rangepicker_styles.default)(DateRangePickerDropDown);

exports.default = _default;